<query-builder #queryBuilder [(ngModel)]='query' [config]='config' [allowRuleset]="allowRuleset">

  <ng-container *queryField="let rule; let fields=fields; let onChange=onChange">
    <div class="query-field">
      <select [(ngModel)]="rule.field"
              (ngModelChange)="onChange($event, rule)">
        <option *ngFor="let field of fields" [ngValue]="field.value" [class]="field.styleClass">
          {{field.name}}
        </option>
      </select>
    </div>
  </ng-container>

  <ng-container *queryInput="let rule; type: 'betweenNumber'">
    <between-numbers [(model)]="rule.value"></between-numbers>
  </ng-container>
  <ng-container *queryInput="let rule; type: 'betweenDate'">
    <between-dates [(model)]="rule.value"></between-dates>
  </ng-container>
  <ng-container *queryInput="let rule; type: 'date'">
    <mojo-date [(model)]="rule.value"></mojo-date>
  </ng-container>
  <ng-container *queryInput="let rule; type: 'multiselect'; ">
    <p-multiSelect
      appendTo="body"
      [options]="getOptions(rule)"
      [(ngModel)]="rule.value"
      optionLabel="name"
      optionValue="value"></p-multiSelect>
  </ng-container>
</query-builder>
